import React, {useState} from 'react';
import {Text} from '@/ui-kits';
import {cn} from '@/utils/common_functions';
import {CategoryManagement} from './CategoryManagement';
import {FilterConfiguration} from './FilterConfiguration';
import {PopularSpecialistManagement} from './PopularSpecialistManagement';

enum Tab {
  FilterConfiguration = 'filter-configuration',
  CategoryManagement = 'category-management',
  PopularSpecialists = 'popular-specialists',
}

const tabs = [
  {id: Tab.FilterConfiguration, label: 'Filter Configuration'},
  {id: Tab.CategoryManagement, label: 'Category Management'},
  {id: Tab.PopularSpecialists, label: 'Popular Specialists'},
];

export const SpecialistDisplayScreen: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>(Tab.FilterConfiguration);

  const renderContent = () => {
    switch (activeTab) {
      case Tab.FilterConfiguration:
        return () => <FilterConfiguration />;
      case Tab.CategoryManagement:
        return () => <CategoryManagement />;
      case Tab.PopularSpecialists:
        return () => <PopularSpecialistManagement />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <div className="max-w-7xl mx-auto w-full">
        <div className="flex gap-1 sm:gap-2 w-full px-2 sm:px-4 pt-6 mb-6">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={cn(
                'flex-1 rounded-lg transition-all duration-200 border h-auto min-h-12 px-1 sm:px-4 py-2 sm:py-3',
                'flex items-center justify-center text-center text-[15px] sm:text-sm md:text-base lg:text-lg whitespace-normal break-words',
                activeTab === tab.id
                  ? 'bg-white text-gray-800 border-gray-300 shadow-sm font-FigtreeBold'
                  : 'bg-gradient-to-tr from-[#DBF1FC] to-[#CBEBFB] text-gray-500 border-none hover:from-[#C7E8F8] hover:to-[#B8E3F6] font-FigtreeMedium',
              )}>
              <span className="bg-gradient-to-r from-ui_blue to-ui_blue_light bg-clip-text text-transparent leading-tight">
                {tab.label}
              </span>
            </button>
          ))}
        </div>

        <div className="px-4 pb-4 w-full">
          {renderContent()?.()}
        </div>
      </div>
    </div>
  );
};
